import React from 'react'
import styles from './BookingModalInfo.module.scss';
import { formatMinutes } from '@kursk/utils/format';
import { pluralize } from '@kursk/utils/pluralize';
import { ClockIcon } from '../../icons';
import { FlagIcon } from '../../icons.astrakhan';
import { getInfoBlockItem } from "@kursk/utils/getInfoBlockData";
import {
  EXCURSION_MULTIPLE_HASHES,
  EXCURSION_SINGLE_HASHES
} from "@kursk/components/pages/SingleExcursion/constants/constants";
import { TOUR_MULTIPLE_HASHES, TOUR_SINGLE_HASHES } from "@kursk/components/pages/SingleTour/constants/constants";

export const BookingModalInfo = ({ entityType, entity }) => {
  const info = entityType === 'excursions' ?
    getInfoBlockItem(
      entity.transportationMethod,
      'transportationMethod',
      EXCURSION_SINGLE_HASHES,
      EXCURSION_MULTIPLE_HASHES
    ) :
    getInfoBlockItem(
      entity.transportationMethod,
      'transportationMethod',
      TOUR_SINGLE_HASHES,
      TOUR_MULTIPLE_HASHES
    )

  const duration = 'duration' in entity ?
    formatMinutes(entity.duration) :
    `${entity.tourProgram.length} ${pluralize('день', entity.tourProgram.length)}`

  return (
    <div className={styles.info}>
      <div className={styles.infoItem}>
        <div className={styles.infoItem__icon}>{info.icon}</div>
        <div className={styles.infoItem__text}>{info.title}</div>
      </div>
      <div className={styles.infoItem}>
        <div className={styles.infoItem__icon}><ClockIcon /></div>
        <div className={styles.infoItem__text}>{duration}</div>
      </div>
      <div className={styles.infoItem}>
        <div className={styles.infoItem__icon}><FlagIcon /></div>
        <div className={styles.infoItem__text}>{entity.organization.name}</div>
      </div>
    </div>
  )
}
